const drawDateTimeTable = {
  methods: {
    drawTime(datetime) {
      let parts = datetime.split(" ");
      return parts[1];
    },
    drawDate(datetime) {
      let parts = datetime.split(" ");
      return parts[0];
    }
  }
};

export default drawDateTimeTable;
